/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderAccount } from './cloudProviderAccount';
import { ServiceCspUnGated } from './serviceCspUnGated';


export interface VcdsOrg { 
    org_id: string;
    org_name?: string;
    org_type?: string;
    erp_id?: string;
    csp_ungated?: ServiceCspUnGated;
    cloud_provider_accounts?: Array<CloudProviderAccount>;
    licensee_classification?: string;
    vmc_burst_enabled?: boolean;
    vmc_burst_expected?: boolean;
}

